// Toda la plata viaja y se guarda en centavos (Int).
export const ROUNDING_MODES = ['NONE', 'NEAREST', 'UP', 'DOWN'];
export const PRICE_OP_TYPES = ['PERCENT', 'DELTA_CENTS', 'SET_CENTS'];
const arsFormatters = new Map();
function arsFormatter(decimals) {
    let f = arsFormatters.get(decimals);
    if (!f) {
        f = new Intl.NumberFormat('es-AR', {
            style: 'currency',
            currency: 'ARS',
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
        });
        arsFormatters.set(decimals, f);
    }
    return f;
}
/**
 * Formatea centavos como pesos argentinos: 123450 → "$ 1.234,50", 150000 → "$ 1.500".
 * Si el monto es entero no muestra decimales (salvo `decimals` explícito).
 * Ojo: Intl usa espacio duro (U+00A0) entre "$" y el número.
 */
export function formatARS(cents, opts = {}) {
    const decimals = opts.decimals ?? (Math.abs(cents) % 100 === 0 ? 0 : 2);
    return arsFormatter(decimals).format(cents / 100);
}
export function centsToPesos(cents) {
    return cents / 100;
}
export function pesosToCents(pesos) {
    return Math.round(pesos * 100);
}
/**
 * Parsea un monto escrito por el usuario en formato argentino ("1.234,50", "1234.5", "$ 900")
 * y devuelve centavos. Devuelve null si no es un número.
 */
export function parseARS(input) {
    let s = input.replace(/[$\s]/g, '');
    if (!s)
        return null;
    if (s.includes(',')) {
        s = s.replace(/\./g, '').replace(',', '.');
    }
    else if (/^\d{1,3}(\.\d{3})+$/.test(s)) {
        s = s.replace(/\./g, '');
    }
    const n = Number(s);
    return Number.isFinite(n) ? Math.round(n * 100) : null;
}
/** Redondea `cents` a múltiplos de `step` centavos. */
export function roundToStep(cents, step, mode) {
    if (mode === 'NONE' || !Number.isFinite(step) || step <= 0)
        return Math.round(cents);
    const q = cents / step;
    switch (mode) {
        case 'NEAREST':
            return Math.round(q) * step;
        case 'UP':
            return Math.ceil(q - 1e-9) * step;
        case 'DOWN':
            return Math.floor(q + 1e-9) * step;
        default:
            return Math.round(cents);
    }
}
/** Aplica una operación de precio. Redondea al centavo y nunca devuelve negativos. */
export function applyPriceOp(oldCents, op) {
    let next;
    switch (op.type) {
        case 'PERCENT':
            next = oldCents * (1 + op.value / 100);
            break;
        case 'DELTA_CENTS':
            next = oldCents + op.value;
            break;
        case 'SET_CENTS':
            next = op.value;
            break;
        default:
            next = oldCents;
    }
    return Math.max(0, Math.round(next));
}
//# sourceMappingURL=money.js.map